import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./features/landing/landing.component').then((m) => m.LandingComponent),
  },
  {
    path: 'editor',
    loadComponent: () =>
      import('./features/editor/editor.component').then((m) => m.EditorComponent),
  },
  {
    path: 'passenger-info',
    loadComponent: () =>
      import('./features/passenger-info/passenger-info.component').then(
        (m) => m.PassengerInfoComponent,
      ),
  },
  {
    path: 'summary',
    loadComponent: () =>
      import('./features/booking-summary/booking-summary.component').then(
        (m) => m.BookingSummaryComponent,
      ),
  },
  {
    path: 'payment',
    loadComponent: () =>
      import('./features/payment/payment.component').then((m) => m.PaymentComponent),
  },
  {
    path: 'confirmed',
    loadComponent: () =>
      import('./features/confirmed/confirmed.component').then((m) => m.ConfirmedComponent),
  },
  {
    path: 'example',
    loadComponent: () =>
      import('./features/example/example.component').then((m) => m.ExampleComponent),
  },
  {
    path: '**',
    redirectTo: '/',
  },
];
